<template>
  <div>
    <client-only>
    <v-navigation-drawer
      v-if="(!$auth.loggedIn || ($auth.loggedIn && !$auth.user.is_student)) && $vuetify.breakpoint.mdAndDown"
      app
      id="navigationDrawer"
      v-model="$store.state.navigationDrawer"
      fixed
      clipped
      mobile-breakpoint="3000"
      width="240"
      style="background-color: #f5f5f5;border-right: none !important;max-height: 100%"
    >
      <v-list class="hidden-md-and-up" dense>
        <!-- NAVIGATION DRAWER TOGGLE BUTTON -->
        <v-app-bar-nav-icon
          title="Toggle Navigation Drawer"
          style="color:#0000008a; vertical-align: top; margin: 0px 5px;overflow:hidden;"
          @click.stop="toggleNavigationDrawer"
        >
          <v-icon>
            $vuetify.icons.mdiMenu
          </v-icon>
          <span style="text-indent: -999px;">Toggle Navigation Drawer</span>
        </v-app-bar-nav-icon>

        <!-- LOGO LINK -->
        <nuxt-link id="brand1" :to="localePath('/')" title="Go to Elementari Home">
          <nav-logo
            class="icon"
            view-box="0 0 126 36"
            width="100%"
            style="padding: 4px 0; fill: #ff883e;"
            height="100%"
          />
        </nuxt-link>
        <v-divider />
      </v-list>
      <client-only>
        <v-list v-if="!$auth.loggedIn" style="padding: 0;">
          <v-list-item class="sidebar-login">
            <v-btn
              block
              depressed
              color="accent"
              class="flex x12"
              @click="toggleLoginDialog"
            >
              {{ $t('navbar.login.title') }}
            </v-btn>
          </v-list-item>
          <v-divider />
        </v-list>
      </client-only>

      <v-subheader
        class="grey--text text--darken-1"
        style="height:32px; padding-top:10px;text-transform:uppercase"
      >
        {{ $t('links.account') }}
      </v-subheader>

      <v-list dense>
        <v-list-item nuxt :to="localePath('/')">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiHome</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('navbar.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <client-only>
          <div v-if="$auth.loggedIn">
            <v-list-item :to="localePath('/' + $auth.$state.user.username)" nuxt>
              <v-list-item-icon>
                <v-icon>$vuetify.icons.mdiAccountCircleOutline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('navbar.profile.title') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- CLASSROOMS -->
            <v-list-item
              v-if="!$auth.user.is_student && !$auth.user.is_school"
              class="v-list__tile--link"
              nuxt
              exact
              :to="localePath('/')"
            >
              <v-list-item-icon>
                <v-icon>$vuetify.icons.mdiGoogleClassroom</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('navbar.classroom.title') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- CLASROOM LIBRARY -->
            <v-list-item
              v-if="
                $auth.user.is_student &&
                  $store.state.studentSelectClass &&
                  $store.state.studentSelectClass.slug &&
                  !$store.state.studentSelectClass.freemode
              "
              :to="localePath('/classes/' + $store.state.studentSelectClass.slug + '/')"
              nuxt
            >
              <v-list-item-icon>
                <v-icon>$vuetify.icons.mdiGoogleClassroom</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('classroom.myClass') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- NOTIFICATIONS -->
            <v-list-item :to="localePath('/notifications/')" nuxt>
              <v-list-item-icon>
                <v-icon>$vuetify.icons.mdiBellOutline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('navbar.notifications.title') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- SETTINGS -->
            <v-list-item :to="localePath('/settings/')" nuxt>
              <v-list-item-icon>
                <v-icon>$vuetify.icons.mdiCogOutline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('navbar.profile.settings') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </client-only>
      </v-list>

      <v-divider />
      <v-list dense>
        <v-subheader
          class="grey--text text--darken-1"
          style="height:32px; padding-top:10px;text-transform:uppercase"
        >
          {{ $t('links.explore') }}
        </v-subheader>
        <!-- STORIES -->
        <v-list-item :to="localePath('/projects/')" nuxt>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiBookOpenVariant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('stories.title') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item nuxt :to="localePath('/lessons/')">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiNewspaper</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.lessons') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense class="mb-5 pb-5">

       

        <v-list-item :to="localePath('/getting-started/')" nuxt>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiFormatListNumbered</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.getting_started') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item nuxt :to="localePath('/features/')">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiLightbulbOn</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.features') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item nuxt :to="localePath('/what-is-visual-coding/')">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiSwapHorizontal</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.whatIsVisualCoding') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item nuxt :to="localePath('/why-creative-coding/')">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiPaletteOutline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.whyCreativeCoding') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item nuxt :to="localePath('/schools-districts/')">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiSchoolOutline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.schoolsAndDistricts') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="
            !$auth.$state.user || ($auth.$state.user && !$auth.$state.user.is_student) || (!$auth.$state.user && !$auth.$state.user.is_premium)  
          "
          nuxt
          :to="localePath('/plans/')"
        >
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiWalletMembership</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.plans') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          href="https://help.elementari.com"
          target="_blank"
        >
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiHelpCircleOutline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navbar.profile.help') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="localePath('/policy/privacy/')" nuxt>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiSecurity</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('links.privacy') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toggleContactDialog">
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiMessageAlertOutline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navbar.profile.send_feedback') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="localePath('/about/')" nuxt>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiInformationOutline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('links.about') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>$vuetify.icons.mdiWeb</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="pa-0">
            <v-select
              v-model="$i18n.locale"
              :items="$i18n.locales"
              item-text="name"
              item-value="code"
              dense
              hide-details
              class="small-select mt-0"
              @change="changeLangSelect"
            />
          </v-list-item-content>
        </v-list-item>
        <client-only>
          <v-list-item v-if="$auth.loggedIn" @click="logOut">
            <v-list-item-icon>
              <v-icon>$vuetify.icons.mdiLogout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('navbar.profile.log_out') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </client-only>
      </v-list>
    </v-navigation-drawer>
    </client-only>
    <v-app-bar app dense fixed clipped-left :elevate-on-scroll="isNavbarElevated()" style="width: 100%">
      <!-- NAVIGATION DRAWER TOGGLE BUTTON -->
      <v-app-bar-nav-icon
        title="Toggle Navigation Drawer"
        v-show="$vuetify.breakpoint.mdAndDown && !mobileSearchToggle && (!$auth.loggedIn || ($auth.loggedIn && $auth.user && !$auth.user.is_student))"
        style="color:#0000008a"
        @click.stop="toggleNavigationDrawer"
      >
        <v-icon>
          $vuetify.icons.mdiMenu
        </v-icon>
        <span style="text-indent: -999px;">Toggle Navigation Drawer</span>
      </v-app-bar-nav-icon>

      <!-- LOGO LINK -->
      <nuxt-link
        v-show="!mobileSearchToggle"
        id="brand"
        :to="localePath('/')"
        title="Go to Elementari Home"
        style="overflow:hidden;"
      >
        <nav-logo
          class="icon"
          view-box="0 0 126 36"
          viewBox="0 0 126 36"
          width="100%"
          height="100%"
        />
        <span style="text-indent: -999px;">Elementari</span>
      </nuxt-link>


    <v-menu
      
      transition="slide-y-transition"
      open-on-hover
      offset-y
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        v-show="$vuetify.breakpoint.lgAndUp && (!$auth.loggedIn || ($auth.loggedIn && $auth.user && !$auth.user.is_student))"
          class="navbar-btn"
          text
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('links.explore') }} <v-icon>$vuetify.icons.mdiChevronDown</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item nuxt :to="localePath('/lessons/')">
          <v-list-item-title>{{ $t('links.lessons')}}</v-list-item-title>
        </v-list-item>
        <v-list-item nuxt :to="localePath('/projects/')">
          <v-list-item-title>{{ $t('links.stories')}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
     
      transition="slide-y-transition"
      open-on-hover
      offset-y
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
         v-show="$vuetify.breakpoint.lgAndUp && (!$auth.loggedIn || ($auth.$state.loggedIn && $auth.$state.user &&  !$auth.$state.user.is_student))"
          class="navbar-btn"
          text
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('links.resources') }} <v-icon>$vuetify.icons.mdiChevronDown</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item nuxt :to="localePath('/getting-started/')">
          <v-list-item-title >
            {{ $t('links.getting_started') }}
          </v-list-item-title>          
        </v-list-item>
        
        <v-list-item nuxt :to="localePath('/features/')">
          <v-list-item-title>{{ $t('links.features') }}</v-list-item-title>
        </v-list-item>

        <v-list-item nuxt :to="localePath('/what-is-visual-coding/')">
          <v-list-item-title>{{ $t('links.whatIsVisualCoding') }}</v-list-item-title>
        </v-list-item>

        <v-list-item nuxt :to="localePath('/why-creative-coding/')">
          <v-list-item-title>{{ $t('links.whyCreativeCoding') }}</v-list-item-title>
        </v-list-item>
        
        <v-list-item v-show="$i18n.locale == 'en'" nuxt :to="'/pathfinders-summer-pd-2025/'">
          <v-list-item-title>{{ $t('links.professionalDevelopment') }}</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://help.elementari.com">
          <v-list-item-title>{{ $t('links.help_center') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn  v-show="(!$auth.loggedIn || ($auth.$state.loggedIn && $auth.$state.user && !$auth.$state.user.is_student)) && $vuetify.breakpoint.lgAndUp" class="hidden-xs-only navbar-btn" text display="d-flex" nuxt :to="localePath('/schools-districts/')">
      {{ $t('links.schoolsAndDistricts') }}
    </v-btn>
    
    
    <v-btn  v-show="(!$auth.loggedIn || ($auth.$state.loggedIn && $auth.$state.user && !$auth.$state.user.is_student)) && $vuetify.breakpoint.lgAndUp" class="hidden-xs-only navbar-btn" text display="d-flex" nuxt :to="localePath('/plans/')">
      {{ $t('links.plans') }}
    </v-btn>
        
<!-- 
      <v-text-field
        v-show="mobileSearchToggle"
        id="mobileSearchInput"
        ref="mobileSearchInput"
        v-model="searchQuery"
        :placeholder="$t('navbar.search_stories.search')"
        height="38"
        @keyup.enter="searchSubmit"
      />
      <v-spacer v-show="!mobileSearchToggle" /> -->
      <v-spacer />

      <!-- SEARCH TEXTFIELD -->
      <!-- <v-layout class="hidden-sm-and-down">
        <v-flex id="searchContainer">
          <div id="search-input" slot="search-input">
            <input
              v-model="searchQuery"
              :placeholder="$t('navbar.search_stories.search')"
              :aria-label="$t('navbar.search_stories.search')"
              autocapitalize="none"
              autocomplete="off"
              autocorrect="off"
              name="search_query"
              tabindex="0"
              type="text"
              spellcheck="false"
              aria-haspopup="false"
              role="combobox"
              aria-autocomplete="list"
              dir="ltr"
              class="searchBox"
              @keyup.enter="searchSubmit"
            />
          </div>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="searchIcon"
              :aria-label="$t('navbar.search_stories.search')"
              text
              @click="searchSubmit"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>$vuetify.icons.mdiMagnify</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('navbar.search_stories.search') }}</span>
        </v-tooltip>
      </v-layout> -->
      <!-- <v-spacer v-show="!mobileSearchToggle" /> -->
      <!-- <v-toolbar-items class="hidden-md-and-up">
        <v-btn
          text
          icon
          color="#0000008a"
          @click="toggleMobileSearchButton"
          style="overflow:hidden"
        >
          <v-icon>$vuetify.icons.mdiMagnify</v-icon>
          <span style="text-indent: -999px;">Search</span>
        </v-btn>
      </v-toolbar-items> -->
      <client-only>

        <v-toolbar-items v-if="$auth.loggedIn" class="hidden-sm-and-down">
          <!-- NOTIFICATIONS -->
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              
            </template>
            <span>{{ $t('navbar.notifications.tooltip') }}</span>
          </v-tooltip> -->

          <!-- <notification-navbar /> -->

          <upload-navbar
            v-if="
              $auth.$state.user.is_staff || $auth.$state.user.studio_whitelist
            "
          />
        </v-toolbar-items>
        
       
        <!-- <v-toolbar-items> -->
          <div  v-if="!$auth.loggedIn" class="hidden-xs-only">
            <v-btn color="accent" depressed class="d-flex navbar-btn" @click="toggleSignupDialog">
              {{ $t('navbar.signup.title') }}
            </v-btn>


            <sign-up-as-form :sign-up-dialog="signUpDialog"></sign-up-as-form>
          </div>
        <!-- </v-toolbar-items> -->

        <v-menu
          v-show="$vuetify.breakpoint.lgAndUp"
          transition="slide-y-transition"
          open-on-hover
          offset-y
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="navbar-btn"
              text
              color="#0000008a"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>$vuetify.icons.mdiTranslate</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item  v-for="lang in $i18n.locales" :key="lang.code" @click="changeLangSelect(lang.code)">
              <v-list-item-title >
                {{ lang.name }}
              </v-list-item-title>          
            </v-list-item>
          </v-list>
        </v-menu>

        <v-toolbar-items v-if="$auth.loggedIn && $auth.$state.user" >
          <v-btn
            v-if="$auth.loggedIn && $auth.$state.user && $auth.user.is_student && unlocalizedPath !== '/'"
            outlined
            class="hidden-xs-only change-class-btn"
            style="height: 36px !important; margin: 6px 0px;"
            :to="localePath('/')"
            @click.native.stop
          >
              {{ $t('classroom.changeClass') }}
          </v-btn>
          
          <v-btn
            v-if="!$auth.user.is_student || ($auth.user.is_student && unlocalizedPath == '/')"
            depressed
            nuxt
            :to="localePath('/studio/')"
            class="px-2 mr-3 ml-2 hidden-xs-only"
            :outlined="$auth.user.is_student ? true : false"
            :color="$auth.user.is_student ? 'rgb(129, 129, 129)' : 'accent'"
            style="height: 36px !important; margin: 6px 0px;"
          >
            <v-icon size="20" class="mr-2">$vuetify.icons.mdiLeadPencil</v-icon>
            <span v-if="!$auth.user.is_student">{{ $t('actions.create') }}</span>
            <span v-else>{{ $t('classroom.createForFun') }}</span>
          </v-btn>
          
          <login-navbar-menu v-if="!$auth.user.is_student"/>

          <v-tooltip v-if="$auth.user.is_student" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              fab
              depressed
              text
              class="ml-2"
              @click="logOut"
              >
                <v-icon color="#818181">$vuetify.icons.mdiLogout</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('navbar.profile.log_out') }}</span>
          </v-tooltip>
        </v-toolbar-items>
      </client-only>
    </v-app-bar>

    <v-dialog
      :value="contactDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title class=" blue-purple-gradient">
          <span>{{ $t('navbar.profile.send_feedback') }}</span>
          <v-spacer />
          <v-btn class="ma-0" text icon @click="toggleContactDialog">
            <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <contact-form />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavLogo from '@/assets/svg/elementari-logo.svg?inline'
import SignUpAsForm from '~/components/forms/account/SignUpAsForm'
// import JoinClassForm from '~/components/forms/classroom/JoinClassForm'
// import SignupForm from '~/components/forms/account/SignupForm'
export default {
  components: {
    NavLogo,
    // JoinClassForm,
    SignUpAsForm,
    // SignupForm,
    // 'login-form': () => import('~/components/forms/account/LoginForm.vue'),
    'contact-form': () => import('~/components/forms/ContactForm.vue'),
    'login-navbar-menu': () => import('~/components/utils/LoginNavbarMenu.vue'),

    'upload-navbar': () => import('~/components/utils/UploadNavbar.vue')
  },
  props: {
    path: {
      type: [String],
      required: true,
      default: ''
    }
  },
  data: () => ({
    signUpDialog: false,
    changePlanDialog: false,
    mobileSearchToggle: false,
    classcode: '',
    studentstep: 1,
    forwardToClassroom: false,
    transparentPages: [
      '/features/',
      '/projects/',
      '/about/',
      '/educators/',
      '/artists/',
      '/researchers/',
      '/about/',
      '/hourofcode/',
      '/grants/',
      '/quote/',
      '/projects/',
      '/lessons/',
      '/'
    ]
  }),
  mounted: function() {
    const vue = this
    let searchInput = document.getElementById('mobileSearchInput')
    if (searchInput) {
      document
        .getElementById('mobileSearchInput')
        .addEventListener('focusout', function() {
          vue.mobileSearchToggle = false
        })
    }
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    
    ...mapState(['loginDialog']),
    ...mapState(['signupDialog']),
    // ...mapState(['studentSignupDialog']),
    // ...mapState(['teacherSignupDialog']),
    ...mapState(['contactDialog']),
    navigationOpen() {
      return
    },
    unlocalizedPath() {
      const localePrefix = this.$i18n.locale ? `/${this.$i18n.locale}` : ''
      if (this.$route.path.startsWith(localePrefix)) {
        // remove the localePrefix and ensure we return "/" if empty
        const stripped = this.$route.path.replace(localePrefix, '') || '/'
        return stripped
      }
      return this.$route.path
    },
    searchQuery: {
      set(value) {
        this.$store.commit('setSearchQuery', value)
      },
      get() {
        return this.$store.state.searchQuery
      }
    },
    dialog: {
      get() {
        // The dialog is visible if either signupDialog or loginDialog is true
        return this.signupDialog || this.loginDialog;
      },
      set(value) {
        // When closing the dialog (setting to false), both variables are set to false
        if (!value) {
          this.signupDialog = false;
          this.loginDialog = false;
        }
      }
    },
  },
  methods: {
    isNavbarElevated () {
      if (this.unlocalizedPath == '/' && this.$auth.loggedIn) return false

      if (this.transparentPages.includes(this.unlocalizedPath)) return true

      return false
    },
    getWriteRoute(){
      if (this.$auth.loggedIn &&  this.$auth.user && this.$auth.user.is_student) {
        return this.localePath('/');      
      } else {
        return this.localePath('/studio/');
      }
    },
    goNextStep(value) {
      this.studentstep = 2
      this.classcode = value
    },
    logOut() {
      const url = this.localePath('/')
      
      this.$store.dispatch('LOGOUT')
      this.$router.push(url)
    },
    changeLangSelect(code) {
      this.changeLangCookie(code)
      this.setLangAPI(code)
    },
    changeLangCookie(code) {
      this.$cookies.set('locale', code, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7
      })
      this.$cookies.set('i18n_redirected', code, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7
      })
      this.$i18n.setLocale(code)
      this.$i18n.locale = code
      this.$dayjs.locale(code)
    },
    async setLangAPI(code) {
      const formdata = {
        lang: code
      }

      if (this.$auth.loggedIn) {
        try {
          const res = await this.$api.editUserProfile(
            this.$auth.user.username,
            formdata
          )
        } catch (e) {
          console.log(e)
        }
      }

      this.$store.dispatch('CHANGE_LANG', code)
      // location.reload()
    },
    toggleNavigationDrawer() {
      this.$store.commit(
        'setNavigationDrawer',
        !this.$store.state.navigationDrawer
      )
    },
    toggleContactDialog() {
      this.$store.dispatch('setContactDialog', !this.$store.state.contactDialog)
    },
    toggleLoginDialog() {
      this.$store.dispatch('setLoginDialog', !this.$store.state.loginDialog)
    },
    // toggleStudentSignupDialog() {
    //   this.$store.dispatch(
    //     'setStudentSignupDialog',
    //     !this.$store.state.studentSignupDialog
    //   )
    // },

    // toggleTeacherSignupDialog(forwardToClassroom) {
    //   this.forwardToClassroom = forwardToClassroom
    //   this.$store.dispatch(
    //     'setTeacherSignupDialog',
    //     !this.$store.state.teacherSignupDialog
    //   )
    // },

    toggleSignupDialog() {
      this.$store.dispatch('setSignupDialog', !this.$store.state.signupDialog)
    },
    // changeForms() {
    //   if (
    //     this.$store.state.teacherSignupDialog ||
    //     this.$store.state.studentSignupDialog
    //   ) {
    //     this.toggleSignupDialog()
    //   }
    //   this.toggleSignupDialog()
    //   this.toggleLoginDialog()
    // },
    searchSubmit() {
      this.$router.push({
        path: this.localePath('/projects/'),
        query: { q: this.$store.state.searchQuery }
      })
    },
    toggleMobileSearchButton() {
      this.mobileSearchToggle = !this.mobileSearchToggle
      if (!this.mobileSearchToggle) {
        this.searchSubmit()
      } else {
        // focus mobile search input
        this.$nextTick(this.$refs.mobileSearchInput.focus)
      }
    }
  }
}
</script>
<style scoped>
.v-stepper {
  box-shadow: none;
}
</style>

<style>
.changePlanHeadline {
  background: linear-gradient(133deg, #00c4cc 10%, #7d2ae8 90%);
  color: #fff;
}

.ptprice {
  background-color: #42a5f5;
  border-radius: 6px;
  width: 100%;
  max-width: 100%;
  padding: 15px;
  margin: 0 auto;
  position: relative;
  text-align: center;
}

.ptprice .icon {
  -webkit-transform: rotate(20deg);
  transform: rotate(20deg);
  padding-top: 14px;
  color: #fff;
  font-size: 12px;
  display: inline-block;
  width: 65px;
  height: 65px;
  background-color: orange;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -4px;
}
.ptprice__header {
  padding-bottom: 15px;
  padding-bottom: 0.9375rem;
}

.ptprice__value {
  font: 50px/1 Muller-Medium, Arial, Helvetica Neue, Helvetica, sans-serif;
  color: #fff;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.23);
}

.ptprice__text {
  font: 12px/1 Muller-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
  color: #fff;
}
.ptprice__value span {
  font: 25px/1 Muller-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
}
.ptprice__title {
  font-size: 18px !important;
  color: #fff;
  text-transform: uppercase;
  margin: 0;
  font-weight: 500;
}
#navigationDrawer .v-list--two-line .v-list__tile {
  height: auto;
}

.small-select .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.small-select .v-select__selections {
  padding-top: 0px !important;
}
.small-select .v-input__append-inner {
  margin-top: 4px !important;
}
.small-select {
  font-size: 13px;
  padding-top: 0px !important;
}
/* 
#searchContainer {
  position: relative;
  align-items: center;
  border-radius: 2px;
  padding: 0 8px;
  -ms-flex: 1 1 0.000000001px;
  -webkit-flex: 1;
  flex: 1;
  -webkit-flex-basis: 0.000000001px;
  flex-basis: 0.000000001px;
  display: flex;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  height: 32px;
  width: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-right: none;
  box-shadow: inset 0 1px 2px #eee;
  padding: 2px 6px;
  border-radius: 2px 0 0 2px;
}

#searchContainer:focus-within {
  border: 1px solid #1c62b9;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
}

#search-input {
  width: 100%;
}

.searchBox {
  width: 100%;
  outline: none;
}

#searchIcon {
  cursor: pointer;
  width: 65px !important;
  border: 1px solid #d3d3d3;
  background-color: #f8f8f8;
  border-radius: 0 2px 2px 0;
  margin: 0;
  height: 32px;
}

#mobileSearchInput {
  padding-bottom: 2px;
} */

#brand,
#brand1 {
  height: 50px;
  width: 150px;
}
#brand svg,
#brand1 svg {
  padding: 10px 0;
  width: 120px;
  height: 100%;
  fill: #ff883e;
}

#selectLoginType .v-btn__content {
  display: block !important;
  max-width: 100%;
}

.v-app-bar {
  background-color: #fff!important;
  border-color: #fff!important;
}

.v-app-bar--hide-shadow {
  background-color: transparent!important;
  border-color: transparent!important;
}

.v-app-bar--hide-shadow .navbar-btn {
  color: white !important;
}

.v-app-bar--hide-shadow svg {
  fill: white !important;
}

.change-class-btn {
  color: #1976d2;
  caret-color: #1976d2;
}

.v-app-bar--hide-shadow .change-class-btn {
  color: white;
  caret-color: white;
}
  

</style>